import styles from './FlexBetween.module.css';

const FlexBetween = ({ children, style }) => {
  return (
    <div className={styles.flex} style={style}>
      {children}
    </div>
  );
};

export default FlexBetween;
